import JsSIP from 'jssip';

var WSS_URL = (window.env && window.env.wssUrl) || 'wss://wss-dakenh.lsd.vn/ws';
var SIP_DOMAIN = (window.env && window.env.sipDomain) || 'wss-dakenh.lsd.vn';

class WebRTCPhone {
    constructor() {
        this.ua = null;
        this.currentSession = null;
        this.registered = false;
        this.pendingCallout = false; // Flag: CMS vua bam callout
        this.listeners = { registered: [], unregistered: [], incomingCall: [], callConnected: [], callEnded: [], callFailed: [], ringing: [] };
    }

    // Goi tu CMS: set flag truoc khi ARI ring
    setPendingCallout(value) {
        this.pendingCallout = value;
    }

    register(extension, password) {
        if (this.ua) this.ua.stop();
        var socket = new JsSIP.WebSocketInterface(WSS_URL);
        var configuration = { sockets: [socket], uri: 'sip:' + extension + '@' + SIP_DOMAIN, password: password, display_name: extension, register: true, session_timers: false };
        this.ua = new JsSIP.UA(configuration);
        this.ua.on('registered', function() { this.registered = true; this._emit('registered'); }.bind(this));
        this.ua.on('unregistered', function() { this.registered = false; this._emit('unregistered'); }.bind(this));
        this.ua.on('registrationFailed', function() { this.registered = false; this._emit('unregistered'); }.bind(this));
        this.ua.on('newRTCSession', function(data) {
            var session = data.session;
            if (session.direction === 'incoming') {
                this.currentSession = session;
                this._setupSessionEvents(session);
                var callerNum = session.remote_identity.uri.user || '';
                var callerName = session.remote_identity.display_name || '';
                this._emit('incomingCall', { from: callerNum, displayName: callerName, session: session, isFromCMS: this.pendingCallout });
                console.log("[WebRTC] pendingCallout=", this.pendingCallout, "caller=", callerNum); if (this.pendingCallout) { console.log("[WebRTC] AUTO ANSWERING");
                    // Auto-answer: cuoc goi tu CMS callout
                    this.pendingCallout = false;
                    session.answer({ mediaConstraints: { audio: true, video: false }, pcConfig: { iceServers: [{ urls: 'stun:stun.l.google.com:19302' }] } });
                }
                // Neu KHONG phai tu CMS -> khong auto answer, cho user bam "Nghe may"
            }
        }.bind(this));
        this.ua.start();
    }

    call(target) {
        if (!this.ua || !this.registered) return null;
        var session = this.ua.call('sip:' + target + '@' + SIP_DOMAIN, { mediaConstraints: { audio: true, video: false }, pcConfig: { iceServers: [{ urls: 'stun:stun.l.google.com:19302' }] } });
        this.currentSession = session;
        this._setupSessionEvents(session);
        return session;
    }

    answer() {
        if (this.currentSession && this.currentSession.direction === 'incoming') {
            this.currentSession.answer({ mediaConstraints: { audio: true, video: false }, pcConfig: { iceServers: [{ urls: 'stun:stun.l.google.com:19302' }] } });
        }
    }

    hangup() { if (this.currentSession) { this.currentSession.terminate(); this.currentSession = null; } }
    unregister() { if (this.ua) { this.ua.stop(); this.ua = null; this.registered = false; } }
    sendDTMF(tone) { if (this.currentSession) this.currentSession.sendDTMF(tone); }
    on(event, cb) { if (this.listeners[event]) this.listeners[event].push(cb); }
    off(event, cb) { if (this.listeners[event]) this.listeners[event] = this.listeners[event].filter(function(c) { return c !== cb; }); }
    _emit(event, data) { if (this.listeners[event]) this.listeners[event].forEach(function(cb) { cb(data); }); }
    isRegistered() { return this.registered; }
    isInCall() { return this.currentSession !== null; }

    _setupSessionEvents(session) {
        var self = this;
        session.on('progress', function() { self._emit('ringing'); });
        session.on('accepted', function() { self._attachAudio(session); self._emit('callConnected'); });
        session.on('confirmed', function() { self._attachAudio(session); });
        session.on('ended', function(e) { self.currentSession = null; self._emit('callEnded', { cause: e.cause }); });
        session.on('failed', function(e) { self.currentSession = null; self._emit('callFailed', { cause: e.cause }); });
        session.on('peerconnection', function(data) {
            data.peerconnection.addEventListener('track', function(event) {
                var audio = document.getElementById('remoteAudio') || self._createAudioElement();
                audio.srcObject = event.streams[0];
                audio.play().catch(function() {});
            });
        });
    }

    _attachAudio(session) {
        if (session.connection) {
            var receivers = session.connection.getReceivers();
            if (receivers.length > 0) {
                var stream = new MediaStream();
                receivers.forEach(function(r) { stream.addTrack(r.track); });
                var audio = document.getElementById('remoteAudio') || this._createAudioElement();
                audio.srcObject = stream;
                audio.play().catch(function() {});
            }
        }
    }

    _createAudioElement() {
        var audio = document.createElement('audio');
        audio.id = 'remoteAudio';
        audio.autoplay = true;
        document.body.appendChild(audio);
        return audio;
    }
}

var webrtcPhone = new WebRTCPhone();
export default webrtcPhone;
